import { lazy } from 'react';

export const PrivacyPolicyEmbededPageAsync = lazy(
    () => import('./PrivacyPolicyEmbededPage'),
);
